import React from 'react'
import NumberFormat from 'react-number-format'

import TextField, { TextFieldProps } from '@mui/material/TextField'
import styled from 'styled-components'

const CurrencyField = styled(TextField)`
  & label.Mui-focused {
    color: #142954;
  }
  & .MuiOutlinedInput-root {
    &.Mui-focused fieldset {
      border-color: #142954;
    }
  }
`

function currencyFormatter(value: any) {
  if (!Number(value)) return ''

  const amount = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value / 100)

  return `${amount}`
}

const NumberFormatCustom = React.forwardRef(({ onChange, value, ...props }: any, ref) => {
  const [internalValue, setInternalValue] = React.useState('')

  return (
    <NumberFormat
      value={internalValue ? internalValue : value}
      onValueChange={(values) => {
        setInternalValue(values.value)
        onChange({
          target: {
            name: props.name,
            value: String(Number(values.value) / 100)
          }
        })
      }}
      getInputRef={ref}
      format={currencyFormatter}
      thousandSeparator="."
      decimalSeparator=","
      isNumericString
      {...props}
    />
  )
})

const InputCurrencyBase: React.ForwardRefRenderFunction<any, TextFieldProps> = (
  props,
  ref
) => {
  return (
    <CurrencyField
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      variant="outlined"
      color="primary"
      InputProps={{
        inputComponent: NumberFormatCustom as any,
        style: {
          fontSize: '14px',
          padding: 9
        }
      }}
      inputProps={{ style: { padding: '7.5px 4px 7.5px 5px' } }}
      InputLabelProps={{
        style: {
          fontSize: '14px'
        }
      }}
      FormHelperTextProps={{
        style: {
          fontSize: '12px',
          padding: '7.5px 4px 7.5px 5px'
        }
      }}
      autoComplete="off"
      inputRef={ref}
    />
  )
}

const InputCurrency = React.forwardRef(InputCurrencyBase)

export default InputCurrency
